import {PageLayout} from "base/layout";
import {useOutletContext} from "react-router-dom";
import {MapConfigProvider, MapProvider} from "sisbagal/map";
import {SisbagalMapMenu} from "sisbagal/menu";
import {SisbagalMap} from "sisbagal/map";
import {useAglomeracionData} from "../hooks";
import {useConfigModule} from "base/provider";
import {useEffect} from "react";

const ViewAglomeracionViewerSubPage = () => {
    let aglomeracion;
    [aglomeracion] = useOutletContext();
    const {moduleFilter, setModuleFilter} = useConfigModule();

    const {getEntityData} = useAglomeracionData();

    useEffect(() => {
        if (moduleFilter["subaglomeracion"]) {
            // only cleaning when sistema or subaglomeracion are present in filter
            // to avoid a second api call when changing module filter
            setModuleFilter({...moduleFilter, subaglomeracion: null});
        }
    }, []);

    return (
        <MapConfigProvider>
            <MapProvider
                config={{
                    concello: {
                        visible: false,
                        customClickHandler: () => {}, // Empty click handler because concellos features are not clickable at this map
                    },
                    aglomeracion: {
                        customLoader: () => {
                            return () => Promise.resolve(aglomeracion.geom);
                        },
                        detail: true,
                    },
                    subaglomeracion: {},
                    edar: {},
                    tanque: {},
                    bombeo: {},
                    colector: {visible: false},
                    vertido: {},
                    poligono: {},
                }}
            >
                <PageLayout disablePadding={true}>
                    <SisbagalMap
                        mapOptions={{minZoom: 5}}
                        legend={<SisbagalMapMenu />}
                        showDownloadPdfAction={true}
                        entityData={getEntityData(aglomeracion)}
                    />
                </PageLayout>
            </MapProvider>
        </MapConfigProvider>
    );
};
export default ViewAglomeracionViewerSubPage;
